export default "__VITE_ASSET__e1960fde__"